import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Injectable()
export class BasicAuthorizationInterceptor implements HttpInterceptor {
  private injector = inject(Injector);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const _authenticationService = this.injector.get(AuthenticationService);
    // request = request.clone({
    //   setHeaders: { Authorization: `Basic ${authenticationService.clientId}:${authenticationService.clientSecret}` }
    // });
    return next.handle(request);
  }
}
